// src/validation/vendorSchema.ts
import { z } from "zod";

export const vendorSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Please enter a valid email"),
  phone: z.string().min(1, "Phone is required"),
  location_id: z.string().min(1, "Location is required"),
});
